module.exports = __webpack_public_path__ + "img/blankCanvas.79dd75de.svg";